export default "__VITE_ASSET__26906f79__"